var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1951 1.52336L9.00629 0.336511L12.9046 0L12.5681 3.89834L11.3813 2.70956L7.19082 6.90002L6.00461 5.71381L10.1951 1.52336ZM7.19488 1.40115C7.19488 1.76603 6.89896 2.0613 6.53473 2.0613L6.53468 2.06125C5.39097 2.06125 4.29435 2.5151 3.48529 3.32352C2.67623 4.13137 2.22238 5.22793 2.22173 6.37159C2.22173 7.51529 2.67613 8.6119 3.48464 9.42032C4.29316 10.2287 5.38972 10.6832 6.53337 10.6832C7.67708 10.6826 8.77367 10.2287 9.58144 9.41967C10.3899 8.6105 10.8437 7.51394 10.8437 6.37028C10.8437 6.00605 11.139 5.71013 11.5039 5.71013C11.8681 5.71013 12.164 6.00605 12.164 6.37028C12.164 7.86337 11.5709 9.29517 10.5149 10.3511C9.45968 11.4071 8.02716 12.0002 6.53473 12.0002C5.04164 12.0002 3.60984 11.407 2.55387 10.3511C1.4979 9.29523 0.904785 7.86336 0.904785 6.37028C0.904785 4.87785 1.4979 3.44541 2.55387 2.39008C3.60978 1.33411 5.04165 0.741001 6.53473 0.741001C6.89896 0.741001 7.19488 1.03691 7.19488 1.40115Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLink);
export default __webpack_public_path__ + "static/media/add-link.671793db.svg";
export { ForwardRef as ReactComponent };